import {
  INICIA_SEQUENCIA_ENTURMACAO,
  SALVA_SEQUENCIA_ENTURMACAO,
  REMOVE_SEQUENCIA_ENTURMACAO,
  NOVO_SEQUENCIA_ENTURMACAO,
  BUSCA_SEQUENCIA_ENTURMACAO_EDICAO,
  INICIA_SEQUENCIA_ENTURMACAO_SUCESSO,
  SALVA_SEQUENCIA_ENTURMACAO_SUCESSO,
  REMOVE_SEQUENCIA_ENTURMACAO_SUCESSO,
  BUSCA_SEQUENCIA_ENTURMACAO_EDICAO_SUCESSO,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_SEQUENCIA_ENTURMACAO,
  LISTA_SEQUENCIA_ENTURMACAO_SUCESSO,
  LIMPAR_SEQUENCIA_ENTURMACAO,
  APLICA_FILTRO_SEQUENCIA_ENTURMACAO
} from 'constants/ActionTypes';

export const iniciaSequenciaEnturmacao = () => {
  return {
    type: INICIA_SEQUENCIA_ENTURMACAO,
  };
};

export const inicioSequenciaEnturmacaoSucesso = (lista) => {
  return {
    type: INICIA_SEQUENCIA_ENTURMACAO_SUCESSO,
    payload: lista
  };
};

export const novoSequenciaEnturmacao = () => {
  return {
    type: NOVO_SEQUENCIA_ENTURMACAO,
  };
};

export const listaSequenciaEnturmacao = (filtros) => {
  return {
    type: LISTA_SEQUENCIA_ENTURMACAO,
    payload: filtros
  };
};

export const listaSequenciaEnturmacaoSucesso = (lista) => {
  return {
    type: LISTA_SEQUENCIA_ENTURMACAO_SUCESSO,
    payload: lista
  };
};

export const salvaSequenciaEnturmacao = (sequencia) => {
  return {
    type: SALVA_SEQUENCIA_ENTURMACAO,
    payload: sequencia
  };
};

export const salvaSequenciaEnturmacaoSucesso = (sequencia) => {
  return {
    type: SALVA_SEQUENCIA_ENTURMACAO_SUCESSO,
    payload: sequencia
  };
};

export const buscaSequenciaEnturmacaoEdicao = (id) => {
  return {
    type: BUSCA_SEQUENCIA_ENTURMACAO_EDICAO,
    payload: id
  };
};

export const buscaSequenciaEnturmacaoEdicaoSucesso = (sequencia) => {
  return {
    type: BUSCA_SEQUENCIA_ENTURMACAO_EDICAO_SUCESSO,
    payload: sequencia
  };
};

export const removeSequenciaEnturmacao = (id) => {
  return {
    type: REMOVE_SEQUENCIA_ENTURMACAO,
    payload: id
  };
};

export const removeSequenciaEnturmacaoSucesso = (id) => {
  return {
    type: REMOVE_SEQUENCIA_ENTURMACAO_SUCESSO,
    payload: id
  };
};

export const limparSequenciaEnturmacao = () => {
  return {
    type: LIMPAR_SEQUENCIA_ENTURMACAO,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const onShowLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const onShowSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};

export const onChangeFilterSequenciaEnturmacao = (e) => {
  const value = e.target ? e.target.value : e;
  return { type: APLICA_FILTRO_SEQUENCIA_ENTURMACAO, payload: value };
};
